// import styled from 'styled-components';
// import { darken } from 'polished';

// export const Container = styled.div`
//   flex: 1;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin: 0 auto;
//   height: 100%;
//   width: 100%;
//   max-width: 800px;
// `;

// export const Wrapper = styled.div`
//   flex: 1;
//   > h2 {
//     text-align: center;
//     padding: 60px 20px 120px 20px;
//   }
// `;

// export const Action = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;

//   padding: 5px 10px;

//   > button {
//     border: 0;
//     border-radius: 5px;
//     color: #fff;
//     height: 42px;
//     min-width: 220px;
//   }

//   #btn-action {
//     border: 0;
//     border-radius: 5px;
//     color: #fff;
//     height: 42px;
//     min-width: 220px;
//     background: #2c405a;
//     transition: background 1s;

//     :hover {
//       color: #fff;
//       background: ${darken(0.05, '#2c405a')};
//     }
//   }
// `;

// Action.Export = styled.button`
//   background: #2c405a;
//   transition: background 1s;

//   :hover {
//     background: ${darken(0.05, '#2c405a')};
//   }
// `;

// Action.Home = styled.button`
//   background: #ff6d3c;
//   transition: background 1s;

//   :hover {
//     background: ${darken(0.05, '#ff6d3c')};
//   }
// `;

import styled from 'styled-components';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c (gradiente)   --ink: #17263b / #2c405a
=========================================================== */

const PRIMARY_GRADIENT =
  'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

export const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  max-width: 800px;
`;

export const Wrapper = styled.div`
  flex: 1;

  > h2 {
    text-align: center;
    padding: 60px 20px 120px 20px;
    color: #17263b;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.4px;
    line-height: 1.3;
  }
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;

  > button {
    border: 0;
    border-radius: 12px;
    color: #fff;
    height: 42px;
    min-width: 220px;
    font-weight: 800;
    cursor: pointer;
  }

  #btn-action {
    border: 0;
    border-radius: 12px;
    color: #fff;
    height: 42px;
    min-width: 220px;
    background: #2c405a;
    transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

    :hover {
      color: #fff;
      background: ${darken(0.06, '#2c405a')};
      transform: translateY(-1px);
    }
  }
`;

Action.Export = styled.button`
  background: #2c405a;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  :hover {
    background: ${darken(0.06, '#2c405a')};
    transform: translateY(-1px);
    box-shadow: 0 12px 26px rgba(44, 64, 90, 0.28);
  }
`;

Action.Home = styled.button`
  background: ${PRIMARY_GRADIENT};
  box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
    filter: brightness(1.02);
  }

  :active {
    transform: translateY(0);
  }
`;
